import FooterMega from '../components/shared/global-footer/FooterMega.vue';
import router from '@/routers';
import { createApp } from 'vue';

document.addEventListener('DOMContentLoaded', () => {
  const app = createApp(FooterMega);
  app.use(router);
  app.mount('#footer-mega');
});
